import gql from 'graphql-tag';

export const createMeterReadingValueMutation = gql(/* GraphQL */ `
  mutation createMeterReadingValueMutation(
    $createMeterReadingValue: MeterReadingValueInput
    $channelId: String!
  ) {
    createMeterReadingValue(
      meterReadingValue: $createMeterReadingValue
      channelId: $channelId
    ) {
      id
    }
  }
`);
